import { ContainerModule } from 'inversify';

import { ProjectsFacade } from './facade/projects.facade';
import { FontManager } from './managers/font-manager';
import { TYPES } from './projects.types';
import { ProjectsRepository } from './repositories/projects.repository';
import { ProjectsService } from './services/projects.service';
import { ProjectStoreInjector, useProjectsStore } from './store/projects.store';

export const projectsModule = new ContainerModule((bind) => {
  bind<ProjectStoreInjector>(TYPES.ProjectsStore).toConstantValue(useProjectsStore);

  bind(TYPES.ProjectsFacade).to(ProjectsFacade).inSingletonScope();
  bind(TYPES.ProjectsRepository).to(ProjectsRepository).inSingletonScope();
  bind(TYPES.ProjectsService).to(ProjectsService).inSingletonScope();

  bind(TYPES.FontManager).to(FontManager).inSingletonScope();
});
